// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/reports/${file}.vue`);

export default [
  {
    path: "/reports",
    name: "reports",
    meta: { requiresAuth: true },
    components: {
      content: lazyLoad("reports-list"),
    },
  },
  {
    path: "/reports/:category",
    name: "reports-sales",
    meta: { requiresAuth: true },
    components: {
      content: lazyLoad("reports-list"),
    },
  },
  {
    path: "/report/:category/form/:reportroute",
    name: "reports-form-report",
    meta: { requiresAuth: true },
    components: {
      content: () =>
        import(
          /* webpackChunkName: "form-report" */ `@/templates/form-report.vue`
        ),
    },
  },
  {
    path: "/report/:category/grid/:reportroute*",
    name: "reports-grid-report",
    meta: { requiresAuth: true },
    components: {
      content: () =>
        import(
          /* webpackChunkName: "grid-report" */ `@/templates/grid-report.vue`
        ),
    },
  },

  {
    path: "/report/general-ledger/:type*",
    name: "report-general-ledger-enquiry",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ReportGeneralLedgerEnquiry",
    },
    components: {
      content: lazyLoad("general-ledger-enquiry"),
    },
  },
  {
    path: "/report/:category/invoiced-sales",
    name: "report-invoiced-sales",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ReportInvoicedSales",
    },
    components: {
      content: lazyLoad("invoiced-sales"),
    },
  },
  {
    path: "/report/:category/outstanding-sales-order",
    name: "outstanding-sales-order",
    meta: { requiresAuth: true },
    components: {
      content: lazyLoad("outstanding-sales-order"),
    },
  },
  {
    path: "/report/:category/sales-order-detail",
    name: "sales-order-detail",
    meta: { requiresAuth: true },
    components: {
      content: lazyLoad("sales-order-detail"),
    },
  },

  {
    path: "/report/general-ledger-dev/:type*",
    name: "report-general-ledger-enquiry-dev",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ReportGeneralLedgerEnquiry",
    },
    components: {
      content: lazyLoad("general-ledger-enquiry-dev"),
    },
  },
];
